import Vue from "vue";
import Vuex from "vuex";
import router from "@/router";
import { userInfoApi } from "@/api/user";
import { pcAdApi, pcConfigApi } from "@/api/home";

Vue.use(Vuex);

const initState = () => {
  const token = localStorage.getItem("mall_token") || "";
  let userInfo = {};
  try {
    const userInfoStr = localStorage.getItem("mall_userInfo");
    userInfo = userInfoStr ? JSON.parse(userInfoStr) : {};
  } catch (error) {
    console.error("解析用户信息失败:", error);
  }
  return { token, userInfo };
};

export default new Vuex.Store({
  state: {
    token: initState().token,
    userInfo: initState().userInfo,
    config: {},
    needBindPhone: false,
  },
  getters: {
    token: (state) => state.token,
    userInfo: (state) => state.userInfo,
    config: (state) => state.config,
    needBindPhone: (state) => state.needBindPhone,
  },
  mutations: {
    SETTOKEN(state, token) {
      state.token = token;
      localStorage.setItem("mall_token", token);
    },
    SETUSERINFO(state, userInfo) {
      state.userInfo = userInfo;
      localStorage.setItem("mall_userInfo", JSON.stringify(userInfo));
      state.needBindPhone = !!(userInfo && userInfo.id && !userInfo.mobile);
    },
    WEBCONFIG(state, info) {
      state.config = info;
    },
    SET_NEED_BIND_PHONE(state, value) {
      state.needBindPhone = value;
    },
  },
  actions: {
    setToken: async ({ commit }, value) => {
      commit("SETTOKEN", value);
    },
    setUserInfo: async ({ commit }, value) => {
      commit("SETUSERINFO", value);
    },

    initUserInfo: async ({ commit, dispatch, state }) => {
      if (state.token) {
        try {
          const res = await userInfoApi();
          commit("SETUSERINFO", res.data);
          return res.data;
        } catch (error) {
          console.error("获取用户信息失败:", error);
          await dispatch('logOut');
          throw error;
        }
      }
      return state.userInfo;
    },

    getUserInfo: async ({ commit }, value) => {
      return new Promise((resolve, reject) => {
        userInfoApi()
          .then((res) => {
            commit("SETUSERINFO", res.data);
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    getPcConfigApi: async ({ commit }, value) => {
      return new Promise((resolve, reject) => {
        pcConfigApi().then((res) => {
          commit("WEBCONFIG", JSON.parse(res.data || "{}"));
          resolve(JSON.parse(res.data || "{}"));
        });
      });
    },

    logOut: ({ commit }, value) => {
      commit("SETTOKEN", "");
      commit("SETUSERINFO", {});
      commit("SET_NEED_BIND_PHONE", false);
      localStorage.removeItem("mall_token");
      localStorage.removeItem("mall_userInfo");
      router.push("/");
    },
  },
  modules: {},
});
